import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, graphql } from 'react-apollo';
import { withRouter } from 'react-router';
import { getQuestionsPreview } from 'legacy-src/queries';
import withLearnosityConfig from 'legacy-src/utility/withLearnosityConfig';
import LearnosityProvider from 'legacy-src/utility/LearnosityProvider';

import './QuestionContent.scss';

const QuestionContent = (props) => {
  const { loading, learnosityServerData, onLoadingStart, onLoadingEnd } = props;
  const onLearnosityReady = (app) => {
    onLoadingEnd(app);
  };

  if (!loading && learnosityServerData) {
    onLoadingStart();
    return (
      <Fragment>
        <LearnosityProvider
          containerElement="learnosity_assess_hovering"
          className="qb_hover_preview cb-learnosity-player display-correct-answers invisible"
          data-test-learnosity-provider
          apiType="items"
          initOptions={learnosityServerData}
          readyListener={onLearnosityReady}
        />
      </Fragment>
    );
  }

  return null;
};

QuestionContent.propTypes = {
  onLoadingStart: PropTypes.func,
  onLoadingEnd: PropTypes.func,
  containerElement: PropTypes.string,
};

QuestionContent.defaultProps = {
  onLoadingStart: () => {},
  onLoadingEnd: () => {},
  containerElement: 'learnosity_assess_hovering',
};

const withQuestionsPreview = graphql(getQuestionsPreview, {
  options: ({ questionId, items, learnosityConfig, userData, params }) => {
    /**
     * for QB created Quiz  preview use the questionIds
     * so we get a learnositySignedRequest with all the item references
     * */
    let graphqlParams = {
      questionId,
      questionIds: items.map(({ item_id: itemId }) => itemId),
    };

    const _learnosityConfig = {
      ...learnosityConfig,
      regions: 'items-only',
    };
    delete _learnosityConfig.region_overrides;

    return {
      variables: {
        ...graphqlParams,
        config: JSON.stringify(_learnosityConfig),
        educationPeriod: userData.chosenEducationPeriodCode,
        subjectId: parseInt(params.subject, 10),
        showCorrectAnswers: true,
      },
    };
  },
  props: ({ data }) => {
    const { loading, questionsPreview } = data;
    const { learnositySignedRequest, allowCalculatorForItems, questions } =
      questionsPreview || {};
    const cleanQuestions = (questions || []).map((q) => ({
      ...q,
      itemId: q.id,
    }));

    return {
      loading,
      questions: cleanQuestions,
      learnosityServerData:
        (learnositySignedRequest && JSON.parse(learnositySignedRequest)) ||
        null,
      allowCalculatorForItems,
    };
  },
});

const mapStateToProps = ({ userData }) => ({
  userData,
});

export default compose(
  withRouter,
  connect(mapStateToProps),
  withLearnosityConfig({
    isReviewPlayer: true,
    showCorrectAnswers: true,
    noScroll: true,
  }),
  withQuestionsPreview,
)(QuestionContent);
